import { Component, Input, Output, signal, Signal, EventEmitter, ViewEncapsulation } from '@angular/core';
import { IServiceApplicationTypes, IVesselTransitStatus, IVesselVisit } from '@pmis3/vessel-activity-core';
import { ISeaport } from '@pmis3/ui-features';
import { ILocation, ILocationType, IOrganization, IOrganizationType, IVessel, VesselOrientation, ICargoType, ICargoUnitType, ICargoOperation } from '@pmis3/master-data-core';
import { Store } from '@ngrx/store';

@Component({
    selector: 'app-vessel-visit-webcomponent',
    templateUrl: './vessel-visit-webcomponent.component.html',
    styleUrl: './vessel-visit-webcomponent.component.scss',
    encapsulation: ViewEncapsulation.ShadowDom,
})
export class VesselVisitWebcomponentComponent {

    constructor(private store: Store<any>){
    }

    _vesselVisits = signal([]);
    @Input() set vesselVisits(vvs: any[]) {
        this._vesselVisits.set(vvs);
    }
    get vesselVisits(): Signal<any[]> {
        return this._vesselVisits;
    }

    _vesselVisit = signal(null);
    @Input() set vesselVisit(vv: any) {
        this._vesselVisit.set(vv);
    }
    get vesselVisit(): Signal<any> {
        return this._vesselVisit
    }

    _organizations = signal([]);
    @Input() set organizations(organizations: any[]) {
        this._organizations.set(organizations)
    }
    get organizations(): Signal<any[]> {
        return this._organizations;
    }

    _vesselOrganizations = signal([]);
    @Input() set vesselOrganizations(vos: any[]) {
        this._vesselOrganizations.set(vos);
    }
    get vesselOrganizations(): Signal<any[]> {
        return this._vesselOrganizations;
    }

    _organizationTypes = signal([]);
    @Input() set organizationTypes(types: IOrganizationType[]) {
        this._organizationTypes.set(types)
    }
    get organizationTypes(): Signal<IOrganizationType[]> {
        return this._organizationTypes;
    }

    _vessels = signal([]);
    @Input() set vessels(vessels: IVessel[]) {
        this._vessels.set(vessels);
    }
    get vessels(): Signal<IVessel[]> {
        return this._vessels;
    }

    _locations = signal([]);
    @Input() set locations(locations: ILocation[]) {
        this._locations.set(locations);
    }
    get locations(): Signal<ILocation[]> {
        return this._locations;
    }

    _seaports = signal([]);
    @Input() set seaports(seaports: ISeaport[]) {
        this._seaports.set(seaports);
    }
    get seaports(): Signal<ISeaport[]> {
        return this._seaports;
    }

    _transitStatuses = signal([]);
    @Input() set transitStatuses(statuses: IVesselTransitStatus[]) {
        this._transitStatuses.set(statuses);
    }
    get transitStatuses(): Signal<IVesselTransitStatus[]> {
        return this._transitStatuses;
    }

    _vesselOrientations = signal([]);
    @Input() set vesselOrientations(orientations: any[]) {
        this._vesselOrientations.set(orientations);
    }
    get vesselOrientations(): Signal<any[]> {
        return this._vesselOrientations;
    }

    _vesselStopPurposes = signal([]);
    @Input() set vesselStopPurposes(purposes: any[]) {
        this._vesselStopPurposes.set(purposes);
    }
    get vesselStopPurposes(): Signal<any[]> {
        return this._vesselStopPurposes;
    }

    _ladenStatuses = signal([]);
    @Input() set ladenStatuses(statuses: any[]) {
        this._ladenStatuses.set(statuses);
    }
    get ladenStatuses(): Signal<any[]> {
        return this._ladenStatuses;
    }

    _locationTypes = signal([]);
    @Input() set locationTypes(types: ILocationType[]) {
        this._locationTypes.set(types);
    }
    get locationTypes(): Signal<ILocationType[]> {
        return this._locationTypes;
    }

    _serviceApplicationTypes = signal([]);
    @Input() set serviceApplicationTypes(types: IServiceApplicationTypes[]) {
        this._serviceApplicationTypes.set(types);
    }
    get serviceApplicationTypes(): Signal<IServiceApplicationTypes[]> {
        return this._serviceApplicationTypes;
    }

    _agentOrganizationId = signal<number|undefined>(undefined);
    @Input() set agentOrganizationId(id: number | undefined) {
        this._agentOrganizationId.set(id);
    }
    get agentOrganizationId(): Signal<number|undefined> {
        return this._agentOrganizationId;
    }

    _cargoTypes = signal([]);
    @Input() set cargoTypes(types: ICargoType[]) {
        this._cargoTypes.set(types);
    }
    get cargoTypes(): Signal<ICargoType[]> {
        return this._cargoTypes;
    }
    
    _cargoUnitTypes = signal([]);
    @Input() set cargoUnitTypes(types: ICargoUnitType[]) {
        this._cargoUnitTypes.set(types);
    }
    get cargoUnitTypes(): Signal<ICargoUnitType[]>{
        return this._cargoUnitTypes;
    }

    _cargoOperations = signal([]);
    @Input() set cargoOperations(operations: ICargoOperation[]) {
        this._cargoOperations.set(operations);
    }
    get cargoOperations(): Signal<ICargoOperation[]>{
        return this._cargoOperations;
    }

    // @Output() loadVesselVisitsByDateRange: EventEmitter<{ dateRange: IDateTimeRange }> = new EventEmitter<{ dateRange: IDateTimeRange }>();
    @Output() submitNOA: EventEmitter<any> = new EventEmitter<any>();
    @Output() saveNOA: EventEmitter<any> = new EventEmitter<any>();
    @Output() getVesselVisitById: EventEmitter<number> = new EventEmitter<number>();
    @Output() getVesselVisits: EventEmitter<void> = new EventEmitter();

    @Output() from: EventEmitter<Date> = new EventEmitter<Date>();
    @Output() to: EventEmitter<Date> = new EventEmitter<Date>();
    @Output() searchQuery: EventEmitter<string> = new EventEmitter<string>();
    @Output() statusFilter = new EventEmitter<number[]>();

    onSubmitNOA(noa: any) {
        this.submitNOA.emit(noa);
    }

    onSaveNOA(noa: any) {
        this.saveNOA.emit(noa);
    }

    onGetVesselVisitById(vvId: number) {
        this.getVesselVisitById.emit(vvId)
    }

    // onLoadVesselVisitsByDateRange(event: Event) {
    //     this.from.emit(daterange.dateTimeFrom);
    //     this.to.emit(daterange.dateTimeTo);
    // }

    onLoadVesselVisitsByDateRangeFrom(fromDate: Date) {
        this.from.emit(fromDate)
    }
    onLoadVesselVisitsByDateRangeTo(toDate: Date) {
        this.to.emit(toDate)
    }
    onSearchQuery(query: string) {
        this.searchQuery.emit(query)
    }
    onStatusFilerChange(statusId: number[]) {
        this.statusFilter.emit(statusId)
    }
    onGetVesselVisits() {
        this.getVesselVisits.emit();
    }
}
